import React, { useEffect } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { handleGetCropList, handleGetRegionsList } from "../../store/actions/cropActions";

const AddSchedualerModal = ({
  show,
  handleClose,
  cropScheduallerData,
  setCropScheduallerData,
  errors,
  handleCreateScheduler, // This will create scheduler & trigger task modal open
  isCreatingSchedualer,
}) => {

   const dispatch = useDispatch();
   useEffect(() => {
      handleGetRegionsList(dispatch);
      handleGetCropList(dispatch);
    }, [dispatch]);
  const { regionList, cropList } = useSelector((state) => state.crop);
  //  const cropsList = tenantCropsData?.data?.crops;
// console.log("AddSchedualerModal - regionList:", regionList);
// console.log("AddSchedualerModal - cropList:", cropList);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setCropScheduallerData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <Modal show={show} onHide={handleClose} size="lg" centered backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>Create Crop Scheduler</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Row className="g-3">
            <Col md={6}>
          <Form.Group controlId="schedualer_name" className="mt-3">
            <Form.Label>Scheduler Name<span style={{ color: 'red' }}>*</span></Form.Label>
            <Form.Control
              type="text"
              name="schedualer_name"
              placeholder="Enter scheduler name"
              value={cropScheduallerData.schedualer_name || ""}
              onChange={handleChange}
            />
            {errors?.schedualer_name && (
              <p className="text-danger">{errors.schedualer_name}</p>
            )}
          </Form.Group>
          </Col>
<Col md={6}>
  {/* Select Crop */}
  <Form.Group className="mt-3"> {/* increased from mt-3 to mt-4 for extra top spacing */}
    <Form.Label>
  Select Crop<span style={{ color: 'red' }}>*</span>
</Form.Label>
<Form.Select
  name="cropId"
  value={cropScheduallerData.cropId || ""}
  onChange={handleChange}
   // 👈 add margin above dropdown only
>
  <option value="">Select Crop</option>
  {cropList?.crops?.map((crop) => (
    <option key={crop.id} value={crop.id}>
      {crop.crop_name}
    </option>
  ))}
</Form.Select>


    {errors?.cropId && <p className="text-danger">{errors.cropId}</p>}
  </Form.Group>
</Col>

<Col md={6}>
          {/* Select Region */}
          <Form.Group className="mt-3">
            <Form.Label>Select Region<span style={{ color: 'red' }}>*</span></Form.Label>
            <Form.Select
              name="regionId"
              value={cropScheduallerData.regionId || ""}
              onChange={handleChange}
            >
              <option value="">Select Region</option>
              {regionList?.regions?.map((region) => (
                <option key={region.id} value={region.id}>
                  {region.region}
                </option>
              ))}
            </Form.Select>
            {errors?.regionId && (
              <p className="text-danger">{errors.regionId}</p>
            )}
          </Form.Group>
          </Col>
          </Row>
        </Form>
      </Modal.Body>
      <Modal.Footer className="w-100 d-flex justify-content-center">
        
      <Button
  className="button"
  style={{ padding: "5px 30px" }}
  onClick={handleCreateScheduler}
  disabled={isCreatingSchedualer}
>
  {isCreatingSchedualer ? "Saving..." : "Next"}
</Button>

      </Modal.Footer>
    </Modal>
  );
};

export default AddSchedualerModal;
